module.exports = __webpack_public_path__ + "img/one-logo.7da7d17a.png";